// extracted by mini-css-extract-plugin
export default {"events":"content-product-page_events__hFkPd"};